import { render, staticRenderFns } from "./PayTail.vue?vue&type=template&id=0bf7c82d&scoped=true"
import script from "./PayTail.vue?vue&type=script&lang=js"
export * from "./PayTail.vue?vue&type=script&lang=js"
import style0 from "./PayTail.vue?vue&type=style&index=0&id=0bf7c82d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7c82d",
  null
  
)

export default component.exports